/* eslint-disable no-console */
import constants from "../constants";

const { UPDATE_SUPPORT_CASES_STORE, UPDATE_SUPPORT_CASE_STORE, REMOVE_SUPPORT_CASE_STORE } =
  constants;

const initialState = {};

export default (state = initialState, action) => {
  if (!action) return state;

  const { type } = action;

  switch (type) {
    case UPDATE_SUPPORT_CASES_STORE:
      return Object.values(action.data || {}).reduce((acc, supportCasesByReservation) => {
        Object.values(supportCasesByReservation || {}).forEach((supportCase) => {
          const supportCaseId = supportCase?.supportCaseId;
          if (supportCaseId) acc[supportCaseId] = supportCase;
        });

        return acc;
      }, {});

    case UPDATE_SUPPORT_CASE_STORE: {
      const { supportCase } = action.data;
      const { supportCaseId } = supportCase || {};

      if (!supportCaseId) return state;

      return {
        ...state,
        [supportCaseId]: supportCase,
      };
    }

    case REMOVE_SUPPORT_CASE_STORE: {
      const { supportCaseId } = action.data || {};

      if (!supportCaseId) return state;

      const { [supportCaseId]: _removed, ...rest } = state;

      return {
        ...rest,
      };
    }
    default:
      return state;
  }
};
